/**
 * AJAX filtering for the icon filter grid block.
 * Uses document-level capture phase to intercept clicks BEFORE
 * the Edge theme's page transition handler.
 */
document.addEventListener('click', function(e) {
  var link = e.target.closest('[data-icon-filter-ajax] a');
  if (!link) return;

  var gridEl = document.getElementById('product-grid');
  if (!gridEl) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var sectionId = gridEl.dataset.id;
  var container = link.closest('[data-icon-filter-ajax]');
  var targetUrl = link.getAttribute('href');
  var fetchUrl = targetUrl + (targetUrl.includes('?') ? '&' : '?') + 'section_id=' + sectionId;

  var gridContainer = document.getElementById('ProductGridContainer');
  var collectionEl = gridContainer ? gridContainer.querySelector('.collection') : null;
  if (collectionEl) collectionEl.classList.add('loading');

  fetch(fetchUrl)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var newGrid = doc.getElementById('ProductGridContainer');
      if (newGrid && gridContainer) gridContainer.innerHTML = newGrid.innerHTML;

      ['ProductCount', 'ProductCountDesktop', 'ProductCountMobile'].forEach(function(id) {
        var src = doc.getElementById(id);
        var dst = document.getElementById(id);
        if (src && dst) dst.innerHTML = src.innerHTML;
      });

      if (container) {
        container.querySelectorAll('a').forEach(function(item) {
          item.classList.remove('active');
        });
      }
      link.classList.add('active');

      history.pushState({}, '', targetUrl);

      if (typeof viewMode === 'function') viewMode();
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(gridContainer.innerHTML);
      }

      var headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10
      ) || 0;
      var posTop = gridContainer.offsetTop - headerHeight - 50;
      window.scrollTo({ top: posTop, behavior: 'smooth' });
    })
    .catch(function(err) {
      console.error('Icon filter AJAX error:', err);
      window.location.href = targetUrl;
    });
}, true);
